/* Patch & Willow reviews: page-by-page navigation (Prev/Next) and the customer-photo lightbox. Reports pw:review for PostHog. */
(() => {
  const report = (detail) => document.dispatchEvent(new CustomEvent('pw:review', { detail }));

  // Show only the current page's cards (one page at a time, not cumulative) and draw the pager.
  function paginate(section) {
    const cards = [...section.querySelectorAll('.pw-review')];
    const size = Math.max(1, Number(section.dataset.visible) || cards.length);
    const pages = Math.max(1, Math.ceil(cards.length / size));
    let page = Math.min(Math.max(1, Number(section.dataset.page) || 1), pages);
    section.dataset.page = page;
    const start = (page - 1) * size;
    cards.forEach((card, i) => (card.hidden = i < start || i >= start + size));
    const pager = section.querySelector('[data-pw-pager]');
    if (!pager) return;
    if (pages <= 1) {
      pager.hidden = true;
      pager.innerHTML = '';
      return;
    }
    pager.hidden = false;
    pager.innerHTML =
      `<button type="button" class="button button--tertiary pw-reviews__page-btn" data-pw-page="prev"${page === 1 ? ' disabled' : ''}>← Prev</button>` +
      `<span class="pw-reviews__page-at">Page ${page} of ${pages}</span>` +
      `<button type="button" class="button button--tertiary pw-reviews__page-btn" data-pw-page="next"${page === pages ? ' disabled' : ''}>Next →</button>`;
  }

  document.addEventListener('click', (event) => {
    const section = event.target.closest('[data-pw-reviews]');
    const nav = event.target.closest('[data-pw-page]');
    if (nav && section) {
      section.dataset.page = (Number(section.dataset.page) || 1) + (nav.dataset.pwPage === 'next' ? 1 : -1);
      paginate(section);
      section.scrollIntoView({ block: 'start', behavior: 'smooth' });
      report({ action: 'page', page: Number(section.dataset.page) });
      return;
    }
    const lbNav = event.target.closest('[data-pw-lb]');
    if (lbNav) {
      step(lbNav.dataset.pwLb === 'next' ? 1 : -1);
      return;
    }
    const photo = event.target.closest('[data-pw-photo]');
    if (photo) {
      const box = document.querySelector('[data-pw-lightbox]');
      if (!box) return;
      // every customer photo in the reviews block (strip + cards, all pages), each once
      const root = photo.closest('[data-pw-reviews]') || document;
      gallery = [...new Set([...root.querySelectorAll('[data-pw-photo]')].map((el) => el.dataset.pwPhoto))];
      root.querySelectorAll('[data-pw-photo] img').forEach((img) => {
        if (img.naturalWidth) thumbs[img.closest('[data-pw-photo]').dataset.pwPhoto] = { src: img.currentSrc, ratio: img.naturalWidth / img.naturalHeight };
      });
      show(Math.max(0, gallery.indexOf(photo.dataset.pwPhoto)));
      box.showModal();
      report({ action: 'photo', kind: photo.closest('.pw-review')?.dataset.kind || 'strip' });
      return;
    }
    const box = event.target.closest('[data-pw-lightbox]');
    if (box && event.target === box) box.close(); // tap outside the photo
  });

  // ---- lightbox gallery: arrows, ←/→ keys, swipe ----
  let gallery = [];
  let at = 0;
  const thumbs = {}; // full-size url → { src, ratio } of the thumbnail already on screen
  // ask the CDN for what the screen can show (≤2x), not a fixed 1400px
  function sized(url) {
    const fit = Math.min(window.innerWidth * 0.94, window.innerHeight * 0.82) * Math.min(window.devicePixelRatio || 1, 2);
    return url.replace(/width=\d+/, `width=${Math.min(1400, Math.ceil(fit / 100) * 100)}`);
  }
  function show(i) {
    const box = document.querySelector('[data-pw-lightbox]');
    if (!box || !gallery.length) return;
    at = (i + gallery.length) % gallery.length;
    const img = box.querySelector('img');
    const full = sized(gallery[at]);
    // the cached thumbnail shows at once; the sharp photo replaces it when it lands
    const thumb = thumbs[gallery[at]];
    // fix the box size up front so the small thumbnail fills it instead of jumping
    img.style.width = thumb ? `min(94vw, ${(82 * thumb.ratio).toFixed(2)}dvh)` : '';
    img.src = thumb ? thumb.src : full;
    const sharp = new Image();
    sharp.onload = () => { if (sized(gallery[at]) === full) img.src = full; };
    sharp.src = full;
    [1, -1].forEach((d) => { new Image().src = sized(gallery[(at + d + gallery.length) % gallery.length]); });
    const many = gallery.length > 1;
    box.querySelectorAll('[data-pw-lb]').forEach((b) => (b.hidden = !many));
    const count = box.querySelector('[data-pw-lb-count]');
    if (count) count.textContent = many ? `${at + 1} / ${gallery.length}` : '';
  }
  function step(dir) {
    show(at + dir);
    report({ action: 'photo-nav', dir: dir > 0 ? 'next' : 'prev' });
  }
  document.addEventListener('keydown', (event) => {
    const box = document.querySelector('[data-pw-lightbox]');
    if (!box?.open) return;
    if (event.key === 'ArrowRight') step(1);
    else if (event.key === 'ArrowLeft') step(-1);
  });
  let touchX = null;
  document.addEventListener('touchstart', (event) => {
    if (event.target.closest('[data-pw-lightbox]')) touchX = event.touches[0].clientX;
  }, { passive: true });
  document.addEventListener('touchend', (event) => {
    if (touchX === null) return;
    const dx = event.changedTouches[0].clientX - touchX;
    touchX = null;
    if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
  }, { passive: true });

  document.querySelectorAll('[data-pw-reviews]').forEach(paginate);
})();
